import { Text } from '@chakra-ui/react';
import Link from 'next/link';

const StandardLink = ({ href, text, ...rest }) => (
  <Link href={href} target="_blank" style={{ display: 'inline' }}>
    <Text textDecoration="underline" color="blue.500" cursor="pointer" fontWeight={500} display="inline" {...rest}>
      {text}
    </Text>
  </Link>
);

export default StandardLink;
